import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api'; // Importa o serviço de API configurado

const CatalogoPage = ({ onVoltar, onMateriaClick }) => {
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const [filtro, setFiltro] = useState('todas');

  // Usar React Query para buscar as matérias
  const { data: materias, isLoading: loading, error, refetch } = useQuery({
    queryKey: ['materias'],
    queryFn: async () => {
      try {
        // Tentar obter o token do usuário, mas não é obrigatório para esta rota
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const config = userInfo && userInfo.token ? {
          headers: {
            Authorization: `Bearer ${userInfo.token}`
          }
        } : {};

        const response = await api.get('/api/materias', config, {
          timeout: 10000 // 10 segundos de timeout
        });
        // Correção: o backend retorna um array diretamente, não um objeto com propriedade 'materias'
        const materiasData = Array.isArray(response.data) ? response.data : [];

        // Inicializar estados de carregamento das imagens
        const initialImageLoadingStates = {};
        materiasData.forEach(materia => {
          initialImageLoadingStates[materia._id] = true;
        });
        setImageLoadingStates(initialImageLoadingStates);

        return materiasData;
      } catch (err) {
        console.error('Erro ao buscar matérias:', err);
        if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
          throw new Error('Tempo limite excedido ao carregar as matérias. Verifique sua conexão com a internet.');
        }
        throw new Error('Falha ao carregar as matérias. Tente novamente.');
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutos
    cacheTime: 30 * 60 * 1000, // 30 minutos
    refetchOnWindowFocus: false,
    retry: 2, // Tentar novamente 2 vezes em caso de erro
  });

  // Função para categorizar matérias
  const materiasFiltradas = materias?.filter(materia => {
    if (filtro === 'todas') return true;
    if (filtro === 'humanas' && (
      materia.nome.toLowerCase().includes('história') ||
      materia.nome.toLowerCase().includes('historia') ||
      materia.nome.toLowerCase().includes('geografia') ||
      materia.nome.toLowerCase().includes('filosofia') ||
      materia.nome.toLowerCase().includes('sociologia')
    )) {
      return true;
    }
    if (filtro === 'naturezas' && (
      materia.nome.toLowerCase().includes('química') ||
      materia.nome.toLowerCase().includes('quimica') ||
      materia.nome.toLowerCase().includes('física') ||
      materia.nome.toLowerCase().includes('fisica') ||
      materia.nome.toLowerCase().includes('biologia')
    )) {
      return true;
    }
    if (filtro === 'matematica' && (
      materia.nome.toLowerCase().includes('matemática') ||
      materia.nome.toLowerCase().includes('matematica')
    )) {
      return true;
    }
    if (filtro === 'linguagens' && (
      materia.nome.toLowerCase().includes('português') ||
      materia.nome.toLowerCase().includes('portugues') ||
      materia.nome.toLowerCase().includes('inglês') ||
      materia.nome.toLowerCase().includes('ingles') ||
      materia.nome.toLowerCase().includes('espanhol') ||
      materia.nome.toLowerCase().includes('redação') ||
      materia.nome.toLowerCase().includes('redacao') ||
      materia.nome.toLowerCase().includes('língua portuguesa') ||
      materia.nome.toLowerCase().includes('lingua portuguesa') ||
      materia.nome.toLowerCase().includes('língua inglesa') ||
      materia.nome.toLowerCase().includes('lingua inglesa')
    )) {
      return true;
    }
    return false;
  }) || [];

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-violet-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Carregando catálogo de matérias...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center max-w-2xl mx-auto p-4">
          <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
            </svg>
          </div>
          <p className="text-red-600 font-bold text-xl mb-2">Falha ao carregar as matérias</p>
          <p className="text-gray-600 mb-6">{error.message || 'Ocorreu um erro ao buscar as matérias. Verifique sua conexão com a internet e tente novamente.'}</p>
          <button
            onClick={() => refetch()}
            className="bg-gradient-to-r from-violet-600 to-indigo-600 text-white px-6 py-3 rounded-xl hover:from-violet-700 hover:to-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 font-medium"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-indigo-100">
      <div className="container mx-auto p-4 sm:p-6 md:p-8">
        <header className="flex items-center justify-between mb-8">
          <button
            onClick={onVoltar}
            className="flex items-center text-[#7B2CDB] font-semibold hover:text-[#9B4DFF] transition-colors mr-6"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
        </header>

        <div className="text-center mb-12 mt-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 break-words px-4">
            Catálogo de Matérias
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore nosso catálogo completo de matérias e comece sua jornada de aprendizado
          </p>
        </div>

        {/* Filtro por categoria */}
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {['todas', 'humanas', 'naturezas', 'matematica', 'linguagens'].map((categoria) => (
            <button
              key={categoria}
              onClick={() => setFiltro(categoria)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filtro === categoria
                  ? 'bg-violet-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-violet-100 hover:text-violet-700'
              }`}
            >
              {categoria === 'todas' ? 'Todas' :
               categoria === 'humanas' ? 'Humanas' :
               categoria === 'naturezas' ? 'Naturezas' :
               categoria === 'matematica' ? 'Matemática' :
               'Linguagens'}
            </button>
          ))}
        </div>

        {/* Grade de matérias */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
          {materiasFiltradas.map((materia, index) => (
            <div
              key={materia._id}
              onClick={() => onMateriaClick(materia)}
              className="bg-white rounded-xl shadow-md hover:shadow-xl hover:border-violet-300 hover:scale-[1.02] transition-all duration-300 cursor-pointer overflow-hidden border border-gray-200"
              style={{ transitionDelay: `${index * 25}ms` }}
            >
              <div className="relative h-40 overflow-hidden">
                {imageLoadingStates[materia._id] && (
                  <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                    <div className="w-8 h-8 border-2 border-violet-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                )}
                <img
                  src={materia.imagem}
                  alt={materia.nome}
                  className={`w-full h-full object-cover ${imageLoadingStates[materia._id] ? 'opacity-0' : 'opacity-100'}`}
                  onLoad={() => setImageLoadingStates(prev => ({ ...prev, [materia._id]: false }))}
                  onError={(e) => {
                    e.target.src = `https://placehold.co/400x300/EEF2F5/6B7280?text=${encodeURIComponent(materia.nome)}`;
                    setImageLoadingStates(prev => ({ ...prev, [materia._id]: false }));
                  }}
                />
              </div>

              <div className="p-4">
                <h2 className="text-lg font-semibold text-gray-800 mb-2 text-center">
                  {materia.nome}
                </h2>
                <div className="flex justify-center">
                  <span className="inline-flex items-center px-3 py-1 bg-violet-100 text-violet-800 rounded text-xs font-medium">
                    Explorar
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Anúncio seguro após o conteúdo principal */}
      </div>
    </div>
  );
};

export default CatalogoPage;
